export default __webpack_public_path__ + "f41edcb9fe464f749162804111b7796f.png";